<template>
    <div>
        <form>
            <div class="form-group">
                <div class="row">
                    <div class="col-8">
                        <label>Title</label>
                        <input type="text" v-model="blog.title" class="form-control form-control-lg" />
                    </div>
                    <div class="col-4">
                        <blog-avatar :blog="blog" :w="150" :h="150"/>
                    </div>
                </div>

            </div>
            <div v-if="edit && !isUserBlog" class="form-group">
                <label>URL</label>
                <input type="text" v-model="blog.url" class="form-control" />
            </div>
            <div class="form-group">
                <label>Description</label>
                <textarea v-model="blog.description" class="form-control" rows="3"></textarea>
            </div>
            <div class="form-group">
                <label>Content Type</label>
                <select v-model="blog.contentType" class="form-control">
                    <option value="0">Straight</option>
                    <option value="1">Shemale</option>
                    <option value="2">Gay</option>
                </select>
            </div>
            <div class="form-group">
                <label>Tags</label>
                <input-tag :tags="blog.tags" :on-change="setTags" class="form-control"></input-tag>
            </div>


            <button class="btn btn-primary" @click.prevent="save()">{{buttonLabel}}</button>
            <router-link :to="{name:'MyBlogs'}" tag="button" class="btn btn-default">Cancel</router-link>
        </form>
    </div>
</template>

<script>
    import InputTag from 'vue-input-tag';
    import BlogAvatar from '../../ui/BlogAvatar.vue';

    export default {

        name: '',
        props: {
            edit: {default: false},
            blog: {
                default(){
                    return {
                        title: '',
                        description: '',
                        tags: [],
                        contentType: 0,
                        url: ''
                    }
                }
            }
        },
        data() {
           return {}
        },
        computed: {
            buttonLabel(){
                return this.edit ? 'Save' : 'Create Blog'
            },
            isUserBlog(){
                return (this.blog.url) ? this.blog.url.indexOf('u-')===0 : false;
            }
        },
        created() {
        },
        methods: {
            save(){

                if(this.edit){
                    this.$api.updateBlog(this.blog).then((res)=>{
                        this.$bus.$emit('success', 'Your Blog was updated!');
                        this.$store.dispatch('user/updateBlogs');
                        this.$router.push({name: 'MyBlogs'});
                    })
                } else {
                    this.$api.createBlog(this.blog).then((res)=>{
                        this.$bus.$emit('success', 'Your Blog was created!');
                        this.$store.dispatch('user/updateBlogs');
                        this.$router.push({name: 'MyBlogs'});
                    })
                }

            },
            setTags(tags){
                this.blog.tags = tags;
            }
        },
        components: {
            InputTag,
            BlogAvatar
        },
    }
</script>

<style lang="sass" >

    @import '../../../assets/sass/vars.scss'

    .vue-input-tag-wrapper

        .new-tag
            font-size: 1rem !important
            width: 250px !important

        .input-tag
            font-size: 1rem !important
            color: $colorPrimary !important
            padding: .2em .6em !important
            background-color: lighten($colorPrimary, 40%) !important
            border-color: $colorPrimary !important



            .remove
                color: darken($colorPrimary, 10%) !important

</style>


// WEBPACK FOOTER //
// src/components/user/blogs/BlogForm.vue